var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1012.471,
    height: 85.016,
    viewBox: "0 0 1012.471 85.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "m932.722 5.174-91.4-3.764-95.122.606L653.6 6.7l-88.07-4.3L466.468.277 372 5l-87.573 1.228L189.146 0 92.991 5.074 2.6 3.883 0 81.928 96.855 83.2l91.067-4.8 91.472 5.979 97.127-1.353 92.787-4.578 88.03 1.857 96.562 4.711 95.755-4.95 88.257-.562 94.2 3.878 80.358-2.817V2.378z",
    transform: "rotate(180 506.236 42.508)",
    style: {
      fill: "#629A41"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackground);
export default __webpack_public_path__ + "static/media/blue-background.a61a382ae031d3812b1b88b3dbb6328b.svg";
export { ForwardRef as ReactComponent };